import React, { createContext } from 'react';
import { contextShape, QuickOrderCSVUploadProps } from '../../../types';
import useProductHandlers from '../hooks/useProductHandler';
import useCSVFileHandler from '../hooks/useCSVFileHandler';
import useCSVFileEvents from '../hooks/useCSVFileEvents';

const initialQuickOrderState = {} as contextShape;

const QuickOrderDesktopContext = createContext(initialQuickOrderState);

const QuickOrderDesktopProvider = ({
  downloadLink,
  addItem,
  handleSKUsUpdate,
  onClose,
  children,
}: React.PropsWithChildren<QuickOrderCSVUploadProps>) => {
  const addToCart = async (
    lineItems: {
      sku: string;
      count: number;
      isPreOrder?: boolean;
      commercialOperationKey?: string | null;
    }[],
  ) => {
    return addItem?.(lineItems);
  };

  const {
    files,
    readFiles,
    fileError,
    loading: fileLoading,
    loadingProgress,
    handleFile,
    handleFileReader,
    handleClearFiles,
    handleClearReadFiles,
    handleRemoveClick,
  } = useCSVFileHandler();
  const { handleChange, handleDragLeave, handleDragOver, handleDrop } = useCSVFileEvents(handleFile, handleFileReader);
  const {
    loading: addToCartLoading,
    addToCartError,
    checked,
    products,
    handleUploadClick,
    handleAddToCart,
    onCheckboxChange,
    handleProductClear,
    handleClearAddToCartError,
  } = useProductHandlers(readFiles, handleClearFiles, addToCart, handleSKUsUpdate, onClose);
  return (
    <QuickOrderDesktopContext.Provider
      value={{
        files,
        checked,
        downloadLink,
        loading: fileLoading,
        loadingProgress,
        fileError,
        addToCartLoading,
        addToCartError,
        products,
        handleProductClear,
        handleChange,
        handleClearFiles,
        handleClearReadFiles,
        handleDragLeave,
        handleDragOver,
        handleDrop,
        handleRemoveClick,
        handleUploadClick,
        handleAddToCart,
        onCheckboxChange,
        handleClearAddToCartError,
      }}
    >
      {children}
    </QuickOrderDesktopContext.Provider>
  );
};
export { QuickOrderDesktopContext, QuickOrderDesktopProvider };
